
(function() {
const buyNowVariantsJson = JSON.parse($('.pr_variants_json')[0].innerHTML);
const buyNowPriceList = $('.pr_price_json')[0].innerHTML.split('*');
const buyNowOptionsJson = JSON.parse($('.pr_options_json')[0].innerHTML);
const buyNowSelectEles = $('.buy-now-container .select');

function updateButtonText(variantId) {
  const selectedVariant = buyNowVariantsJson.find(variant => variant.id == variantId);
  const buyNowBtn = $('.buy-now-container .buy-now-btn');
  const buyNowText = buyNowBtn.find('.buy-now-text');
  const soldOutText = buyNowBtn.find('.sold-out-text');
  
  if (selectedVariant && selectedVariant.available) {
    buyNowText.show();
    soldOutText.hide();
    buyNowBtn.removeClass('disabled');
    buyNowBtn.removeAttr('disabled');
  } else {
    buyNowText.hide();
    soldOutText.show();
    buyNowBtn.addClass('disabled');
    buyNowBtn.attr('disabled', 'disabled');
  }
}

$(document).ready(function () {
  console.info('buyNowOptionsJson[0].values.length', buyNowOptionsJson[0].length);
  if (buyNowOptionsJson[0].values.length === 1) {
    buyNowSelectEles.hide();
  }
  buyNowOptionsJson[0].values.forEach((item, index) => {
    Array.from(buyNowSelectEles).forEach((eleItem) => {
      eleItem.appendChild(new Option(item, buyNowVariantsJson[index].id));
    });
  });
   
  const defaultVariantId = $('.buy-now-container .buy-now-btn').attr('data-variant-id');
  updateButtonText(defaultVariantId);
  
  // change variantId to components
  buyNowSelectEles.on('change', function () {
    const selectedVariantId = this.value;
    Array.from(buyNowSelectEles).forEach((eleItem) => {
      eleItem.value = selectedVariantId;
    });
    $('.buy-now-container .buy-now-btn').attr("data-variant-id", selectedVariantId);
    $('.buy-now-container .price').text(buyNowPriceList[this.selectedIndex]);
     
    updateButtonText(selectedVariantId);
  });
});
})();